<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="add-edit-main">
    <vx-card :title="$t('LoginInfo')" v-if="viewLoginInfo">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <vs-input :label="$t('UserName')" v-model="instructorModel.Username" class="mt-5 w-full" name="Username"
            v-validate="'required'" />
          <span class="text-danger text-sm" v-show="errors.has('Username')">{{ errors.first('Username') }}</span>
        </div>

        <div class="vx-col md:w-1/2 w-full">
          <password :model="instructorModel" />
        </div>
      </div>
    </vx-card>

    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full" style="margin-top:20px">
        <label for="Name" class="vs-input--label">{{ $t('Name') }}</label>

        <vs-input class="w-full" v-model="instructorModel.Name" v-validate="'required'" name="Name" />
        <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>

        <div class="mt-5">
          <label for="Current Position" class="vs-input--label ">{{ $t('CurrentPosition') }}</label>
          <vs-input class="w-full " v-model="instructorModel.CurrentPosition" v-validate="'required'"
            name="CurrentPosition" />
          <span class="text-danger text-sm" v-show="errors.has('CurrentPosition')">{{ errors.first('CurrentPosition')
          }}</span>
        </div>

        <div class="mt-4">
          <label class="vs-input--label">{{ $t('Country') }}</label>
          <v-select label="Name" class="w-full" autocomplete v-model="instructorModel.CountryID" :options="listOfCountry"
            :reduce="Country => Country.ID" v-validate="'required'" />
          <!-- <vs-select autocomplete class="mt-5 w-full" label="Country" v-model="instructorModel.listOfCountry" v-validate="'required'" >
                        <vs-select-item :key="index" :value="item.ID" :text="item.Name" v-for="(item,index) in listOfCountry" />
              </vs-select> -->
          <span class="text-danger text-sm" v-show="errors.has('Country')">{{ errors.first('Country') }}</span>
        </div>
        <div class="mt-4">
          <label class="vs-input--label">{{ $t('MaritalStatus') }}</label>
          <v-select label="Name" class="w-full" autocomplete v-model="instructorModel.MaritalStatusID"
            :options="maritalStatuses" :reduce="Marital => Marital.ID" v-validate="'required'" />

          <span class="text-danger text-sm" v-show="errors.has('MaritalStatus')">{{ errors.first('MaritalStatus')
          }}</span>

        </div>

        <div class="mt-4">

          <label for="Status" class="vs-input--label">{{ $t('Status') }}</label>
          <v-select label="Name" class="w-full" v-model="instructorModel.InstructorStatusID"
            :options="listOfInstructorStatus" :reduce="Status => Status.ID" v-validate="'required'" />


          <span class="text-danger text-sm" v-show="errors.has('Country')">{{ errors.first('Country') }}</span>
        </div>

        <vs-input v-if="$acl.check('editor')" :label="$t('DailyRate')" v-model="instructorModel.DailyRate" type="number"
          class="mt-5 w-full" name="DailyRate" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('DailyRate')">{{ errors.first('DailyRate') }}</span>

        <div class="mt-5">
          <label for="Status" class="vs-input--label mr-5">{{ $t('Gender') }}</label>
          <vs-radio v-model="instructorModel.Gender" vs-name="radios1" vs-value="Male">{{ $t('Male') }}</vs-radio>
          <vs-radio v-model="instructorModel.Gender" vs-name="radios1" class="ml-10" vs-value="Female">
            {{ $t('FeMale') }}</vs-radio>
        </div>
      </div>

      <div class="vx-col md:w-1/2 w-full">

        <vs-card style="margin-top:20px">
          <h4>{{ $t('ProfileImage') }}</h4>
          <template>

            <!-- Image Container -->
            <div class="img-container w-64 mx-auto flex items-center justify-center" style="min-height:200px">
              <img :src="baseURL + Attachment" alt="img" class="responsive" v-if="Attachment">
            </div>
          </template>
          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat"
              @click="$refs.updateImgInput.click()">{{ $t('UpdateAttachment') }}</vs-button>
            <vs-button type="flat" color="#999"
              @click="Attachment = null; instructorModel.ImageProfilePath = null">{{$t('RemoveAttachment')}}</vs-button>
          </div>
        </vs-card>

        <div class="mt-4">
          <label class="vs-input--label">{{$t('NationalityRequired')}}</label>
          <v-select label="Name" class="w-full" autocomplete v-model=" instructorModel.NationalityID "
            :options=" nationalities " :reduce=" Nationality => Nationality.ID " v-validate=" 'required' " />
          <span class="text-danger text-sm" v-show=" errors.has('Nationality') ">{{ errors.first('Nationality') }}</span>
        </div>
        <vs-input v-if=" $acl.check('editor') " :label=" $t('DailySubsistence') "
          v-model=" instructorModel.DailySubsistenceAllowance " type="number" class="mt-5 w-full"
          name="DailySubsistenceAllowance" v-validate=" 'required' " />
        <span class="text-danger text-sm" v-show=" errors.has('DailySubsistenceAllowance') ">{{
          errors.first('DailySubsistenceAllowance') }}</span>

      </div>
    </div>
    <div class="vx-row" v-if=" viewLoginInfo ">
      <div class="vx-col md:w-1/2 w-full">
        <vs-input :label=" $t('Mobile') " v-model=" instructorModel.Contacts.Mobile " class="mt-5 w-full" name="Mobile"
          v-validate=" 'required' " />
        <span class="text-danger text-sm" v-show=" errors.has('Mobile') ">{{ errors.first('Mobile') }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <vs-input :label=" $t('PersonalMail') " v-model=" instructorModel.Contacts.Email " class="mt-5 w-full" name="Email"
          v-validate=" 'required' " />
        <span class="text-danger text-sm" v-show=" errors.has('Email') ">{{ errors.first('Email') }}</span>
      </div>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/2 w-full">
        <label class="vs-input--label">{{$t('WorkExperience')}}</label>
        <vs-textarea class="w-full " v-model=" instructorModel.WorkExperience " name="WorkExperience">
        </vs-textarea>
        <span class="text-danger text-sm" v-show=" errors.has('WorkExperience') ">{{ errors.first('WorkExperience')
          }}</span>
      </div>

      <div class="vx-col md:w-1/2 w-full">
        <label class="vs-input--label">{{$t('AchievementsAndActivities')}}</label>
        <vs-textarea class="w-full" v-model=" instructorModel.AchievementsAndActivities " name="AchievementsAndActivities">
        </vs-textarea>
        <span class="text-danger text-sm" v-show=" errors.has('AchievementsAndActivities') ">{{
          errors.first('AchievementsAndActivities') }}</span>
      </div>
    </div>


  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from "@/axios.js"
import moduleNationality from "@/store/settings/nationality/moduleNationality.js";
import moduleMaritalStatus from "@/store/settings/maritalStatus/moduleMaritalStatus.js";
import moduleInstructorStatus from "@/store/settings/instructorStatus/moduleInstructorStatus.js";
import { domain } from '@/gloabelConstant.js';
import password from "../../../views/components/password.vue"

export default {
  components: {
    vSelect,
    password
  },
  props: {
    instructorModel: {
      type: Object,
      required: true,
    },
    viewLoginInfo: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      Attachment: null,
      uploadUrl: domain + "API/Course/UploadFile",
      baseURL: domain,
      update: false,
      // instructorModel: this.data,
      // instructorModel:{},
      listOfCountry: [],
    }
  },
  computed: {
    nationalities() {
      return this.$store.state.nationalityList.nationalities;
    },
    maritalStatuses() {
      return this.$store.state.maritalStatusList.maritalStatuses;
    },
    listOfInstructorStatus() {
      return this.$store.state.instructorStatusList.instructorStatuses;

    }
  },
  methods: {
    updateCurrImg(input) {
      debugger
      if (input.target.files && input.target.files[0]) {
        let data = new FormData()
        data.append('file', input.target.files[0])
        debugger
        axios.post(this.uploadUrl, data)
          .then((response) => {
            this.instructorModel.ImageProfilePath = response.data;
            this.Attachment = response.data;
          })
      }
    },
    getCountries() {
      debugger;
      axios.get("api/Country/GetAll")
        .then((response) => {
          debugger;
          this.listOfCountry = response.data;
        })
    },
    update_avatar() {
      // You can update avatar Here
      // For reference you can check dataList example
      // We haven't integrated it here, because data isn't saved in DB
    }
  },
  created() {
    debugger;
    const ID = this.$route.params.ID;

    //  this.instructorModel=this.data;
    if (ID != undefined && !this.update) {

      this.$store.dispatch("instructorList/GetItemByID", ID)
        .then(res => {
          this.Attachment = res.data.ImageProfilePath;

        })
        .catch(err => {
          debugger;
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err)
        })
    }
    //mkl
    debugger
    this.$store.dispatch("instructorList/GetLoginInstructor").then(res => {
      debugger
      this.Attachment = res.data.ImageProfilePath;
    })
    debugger
    this.getCountries();
    if (!moduleNationality.isRegistered) {
      this.$store.registerModule("nationalityList", moduleNationality);
      moduleNationality.isRegistered = true;
    }
    this.$store.dispatch("nationalityList/fetchDataListItems");
    if (!moduleMaritalStatus.isRegistered) {
      this.$store.registerModule("maritalStatusList", moduleMaritalStatus);
      moduleMaritalStatus.isRegistered = true;
    }
    this.$store.dispatch("maritalStatusList/fetchDataListItems");

    if (!moduleInstructorStatus.isRegistered) {
      this.$store.registerModule("instructorStatusList", moduleInstructorStatus);
      moduleInstructorStatus.isRegistered = true;
    }
    this.$store.dispatch("instructorStatusList/fetchDataListItems");
  }
}
</script>
